import axios, { AxiosInstance } from 'axios';
import setupInterceptorsTo from "./interceptor";
import VueRouter from 'vue-router';

let instance: AxiosInstance | null = null;

const getApi = (baseURL?: string, router?: VueRouter) => {
    if (!instance) {
        instance = setupInterceptorsTo(
            axios.create({
                baseURL,
            }),
            router
        );
    }
    return instance;
}
export default getApi;
